/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card, useMemo } from "@";
import { ThemeGallery } from "@/features/website/themes/components/theme-gallery";
import { mapFormToStoreProject } from "@/features/donations/projects/lib/template-preview/map-form-to-store-project.ts";
import { flattenBanks } from "@/features/donations/projects/lib/template-preview/flatten-banks.ts";

interface Props {
  watch: any;
  setValue: any;
  getValues: any;
  show?: string | undefined;
  register: any;
  errors: any;
}

/**
 * Theme picker for the project's donation page. Delegates rendering to the
 * shared `ThemeGallery` (which fetches active themes and exposes a preview
 * popup); this section just bridges the project form's `themeId` field.
 */
export const ThemeSelectionSection = ({
  watch,
  setValue,
  show,
  errors,
}: Props) => {
  const selectedThemeId = watch("themeId");

  const projectFormData = watch();

  const flatBanks = useMemo(
    () => flattenBanks(projectFormData?.banks?.data),
    [projectFormData?.banks?.data],
  );
  const project = mapFormToStoreProject(projectFormData, flatBanks);

  return (
    <Card title="اختيار ثيم الصفحة" className="lg:col-span-2">
      <ThemeGallery
        value={selectedThemeId}
        onChange={(id) =>
          setValue("themeId", id, {
            shouldDirty: true,
            shouldValidate: true,
          })
        }
        elementData={project}
        disabled={!!show}
        error={errors?.themeId?.message}
      />
    </Card>
  );
};
